import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faPlayCircle, faChevronDown, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import OfertarButton from '../common/OfertarButton';

const stats = [
  { value: '60+', label: 'Anos de história' },
  { value: '700+', label: 'Igrejas no mundo' },
  { value: '5x', label: 'Cultos semanais' },
];

const Hero = () => {
  return (
    <section id="home" className="relative min-h-screen flex flex-col justify-center overflow-hidden bg-[#0a0f1e]">
      <div className="hero-glow-1" />
      <div className="hero-glow-2" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-28 pb-20">
        <div className="grid md:grid-cols-2 gap-12 lg:gap-20 items-center">

          {/* Texto */}
          <div>
            <div className="section-label mb-6">
              <FontAwesomeIcon icon={faMapMarkerAlt} className="text-xs" />
              Parnamirim · RN
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-[3.75rem] font-extrabold text-white leading-[1.1] mb-6 tracking-tight">
              Bem-vindo à{' '}
              <span className="text-gradient block mt-2">
                Lagoinha Cidade Verde
              </span>
            </h1>

            <p className="text-gray-400 text-lg leading-relaxed mb-10 max-w-lg">
              Uma igreja com raízes sólidas e visão global. Aqui há um lugar para cada pessoa — criança, jovem ou adulto.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="#schedules"
                className="flex items-center justify-center gap-2 bg-yellow-500 hover:bg-yellow-400 text-gray-900 px-7 py-3.5 rounded-xl text-base font-bold transition-all duration-200 shadow-lg shadow-yellow-500/20 hover:shadow-yellow-400/30 hover:-translate-y-0.5"
              >
                Ver Cultos <FontAwesomeIcon icon={faCalendarAlt} />
              </a>
              <a
                href="#sermons"
                className="flex items-center justify-center gap-2 bg-white/5 hover:bg-white/10 text-white border border-white/10 hover:border-white/20 px-7 py-3.5 rounded-xl text-base font-semibold transition-all duration-200 hover:-translate-y-0.5"
              >
                Assistir Mensagens <FontAwesomeIcon icon={faPlayCircle} />
              </a>
            </div>

            <div className="md:hidden mt-2">
              <OfertarButton className="w-full" />
            </div>

            {/* Stats */}
            <div className="mt-14 grid grid-cols-3 gap-6 max-w-sm">
              {stats.map((s) => (
                <div key={s.label}>
                  <div className="text-2xl lg:text-3xl font-extrabold text-yellow-400">{s.value}</div>
                  <div className="text-gray-500 text-xs mt-0.5 leading-tight">{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Imagem */}
          <div className="flex justify-center md:justify-end">
            <div className="relative w-full max-w-md">
              <div className="absolute -inset-6 bg-yellow-500/8 rounded-3xl blur-3xl" />
              <img
                src="/images/lagoinha_ilustracao_final.png"
                alt="Igreja Lagoinha Cidade Verde"
                className="relative rounded-2xl w-full h-auto object-cover shadow-2xl ring-1 ring-white/5"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 scroll-down">
        <a href="#about" className="text-gray-600 hover:text-yellow-500 transition-colors">
          <FontAwesomeIcon icon={faChevronDown} className="text-lg" />
        </a>
      </div>
    </section>
  );
};

export default Hero;
